/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlEntityAssetDomainOrderBy = {
    Domain: 'domain',
    Created: 'created',
    Updated: 'updated',
    FirstDetected: 'first_detected',
    Source: 'source',
    SourceAsset: 'source_asset',
    CountFindings: 'count_findings',
    MaxLevel: 'max_level'
} as const;
export type ControlEntityAssetDomainOrderBy = typeof ControlEntityAssetDomainOrderBy[keyof typeof ControlEntityAssetDomainOrderBy];


export function ControlEntityAssetDomainOrderByFromJSON(json: any): ControlEntityAssetDomainOrderBy {
    return ControlEntityAssetDomainOrderByFromJSONTyped(json, false);
}

export function ControlEntityAssetDomainOrderByFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityAssetDomainOrderBy {
    return json as ControlEntityAssetDomainOrderBy;
}

export function ControlEntityAssetDomainOrderByToJSON(value?: ControlEntityAssetDomainOrderBy | null): any {
    return value as any;
}

